<template>
	<div class="list-container">
		<div class="list-header">
			<div class="list-name">{{ list.title }}</div>
			<div class="item-list-value">
				<div class="list-warn" :class="{matched: minMatched}" v-if="list.select_min > 0">{{ minWord }}</div>
				<div class="list-warn" :class="{matched: maxMatched}" v-if="list.select_max > 0">{{ maxWord }}</div>
			</div>
		</div>
		<div class="list-products">
			<CompositeListProduct v-for="product in listProducts" :product="product" @toggle="toggleProduct" :multi="(list?.select_multi && list.select_max !== 1) || !followRules" :disable="followRules && reachedMax && list.select_max !== 1" />
			<div class="no-products" v-if="listProducts.length === 0">{{ getString('no_choice_available') }}</div>
		</div>
	</div>
</template>

<script>
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import CompositeListProduct from "@/console-new/components/ops/counter/CompositeListProduct.vue";
import {useCounterStore, useUserStore} from "@/console-new/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const svgStore = useSvgStore();
		const counterStore = useCounterStore();
		const userStore = useUserStore();
		return {getString: languageStore.getString, userStore, svgStore, counterStore}
	},
	name: "CompositeList",
	components: {CompositeListProduct},
	props: {
		list: {
			type: Object,
			required: true,
			validator: (list) => {
				return list.hasOwnProperty('title') && list.hasOwnProperty('products')
			}
		},
	},
	computed: {
		followRules() {
			return this.userStore.currBusiness.counter_variations_limits;
		},
		listProducts() {
			return Object.values(this.list.products).sort((a, b) => a.order_number - b.order_number);
		},
		minWord() {
			if(this.list.select_min === 1) {
				return this.getString('mandatory');
			} else {
				return this.getString('min_x', [this.list.select_min]);
			}
		},
		maxWord() {
			return this.getString('max_x', [this.list.select_max]);
		},
		minMatched() {
			return this.list.select_min === 0 || this.totalItemsQuantity >= this.list.select_min;
		},
		maxMatched() {
			return this.list.select_max === 0 || this.totalItemsQuantity <= this.list.select_max;
		},
		totalItemsQuantity() {
			let quantity = 0;
			Object.values(this.list.products).forEach(product => {
				quantity += this.counterStore.getProductQuantity(product);
			});
			return quantity
		},
		reachedMax() {
			return (this.list?.select_max || 0) > 0 && this.totalItemsQuantity >= this.list.select_max;
		}
	},
	methods: {
		toggleProduct(product) {
			if(this.list.select_max !== 1 || !this.followRules) {
				return
			}
			for(let i = 0; i < this.listProducts.length; i++) {
				if(this.listProducts[i] !== product && this.counterStore.getProductQuantity(this.listProducts[i]) > 0) {
					this.counterStore.removeProduct(this.listProducts[i]);
					return
				}
			}
		}
	}
}
</script>

<style scoped lang="scss">
.list-container {

	.list-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid var(--color-alpha-2);
		padding-bottom: 5px;

		.list-name {
			font-size: 16px;
			font-weight: 700;
		}

		.item-list-value {
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			align-items: center;
			flex-wrap: wrap;
			gap: 6px;

			.list-warn {
				font-size: 13px;
				line-height: 17px;
				border-radius: 7px;
				color: var(--color-txt-white);
				background-color: var(--color-primary-alpha-4);
				transition: background-color .3s ease;
				padding: 2px 8px;

				&:hover {
					background-color: var(--color-primary-alpha-6);
				}
				&.matched {
					background-color: var(--color-primary);
				}
			}
		}
	}

	.list-products {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-items: center;
		gap: 10px;
		margin-top: 10px;
		margin-bottom: 10px;
		padding-bottom: 10px;

		.list-product {
			width: calc((100% / 3) - (2 * 10px / 3));
			@media (max-width: 1080px) {
				width: calc((100% / 2) - (10px / 2));
			}
			@media (max-width: 600px) {
				width: 100%;
			}
		}

	}
}
</style>